// extracted by mini-css-extract-plugin
export var contentBody = "_d8-9";
export var headerImage = "_d8-2";
export var imageButton = "_d8-7";
export var imageButtonIcon = "_d8-8";
export var imageHeader = "_d8-4";
export var imageHeaderText = "_d8-5";
export var imageOverlay = "_d8-3";
export var imageTitle = "_d8-6";
export var imageWrapper = "_d8-1";
export var taskList = "_d8-a";
export var widget = "_d8-0";